import { apiProductsList } from "api/productApi";
import HashtagIcon from "assets/icons/Hashtag";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import Icon from "components/Shared/atoms/Icon";
import { useFormikContext } from "formik";
import { useAppDispatch, useAppSelector } from "store/store";
import productImage from "assets/images/product-bg.png";

export default function Info() {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x) => x);
  const token = store.businessReducer.business.token;
  const data = useFormikContext<MaterialFormulaData>();
  const v = data.values;

  return (
    <div className="flex flex-wrap items-start justify-between gap-4 md:flex-nowrap">
      {/*-------------------------------------------------------------------------- */
      /*                                  INFO FORM                                  */
      /* -------------------------------------------------------------------------- */}
      <div className="py-8 md:w-1/2">
        <div className="flex flex-col gap-8 md:w-96">
          <BasicSelect
            options={store.productReducer.allProducts}
            label="انتخاب محصول"
            withSearch
            required
            withRefresh
            withClear
            defaultValue={v.productId}
            refreshList={() => dispatch(apiProductsList({ token }))}
            onChange={(val, option: Product) => {
              data.setFieldValue("productId", val);
              data.setFieldValue("product", option);
              data.setFieldValue("quantityUnit", option.unit);
              data.setFieldValue(
                "quantityUnits",
                [option.unit].flatMap((x) => (option.subUnit ? [x, option.subUnit] : [x]))
              );
            }}
            onClear={() => {
              data.setFieldValue("productId", undefined);
              data.setFieldValue("product", undefined);
              data.setFieldValue("quantityUnit", undefined);
              data.setFieldValue("quantityUnits", undefined);
            }}
          />
          {/* <BasicTextInput
            type="number-native"
            label="مقدار تولید شده با فرمول ساخت"
            style={{ padding: "0px 12px 0px 0px" }}
            val={v.quantity}
            arrowHidden
            min={0}
            onChange={(val) => data.setFieldValue("installmentsGap", val)}
            prefix={
              <div className="w-24 my-2 border-r border-gray-200">
                <BasicSelect
                  containerStyle={{ minWidth: 60 }}
                  menuStyle={{ minWidth: 60 }}
                  btnStyle={{ border: "none", minWidth: 60 }}
                  defaultValue={v.quantityUnit}
                  onChange={(val) => data.setFieldValue("quantityUnit", val)}
                  options={v.quantityUnits?.map((x) => ({ label: x, value: x }))}
                />
              </div>
            }
          /> */}
          <BasicTextInput
            label="عنوان فرمول تولید"
            required
            val={v.title}
            onChange={(val) => data.setFieldValue("title", val)}
          />
        </div>
      </div>

      {/*-------------------------------------------------------------------------- */
      /*                                  INFO BOX                                  */
      /* -------------------------------------------------------------------------- */}
      <div className="flex items-center justify-center py-8 md:w-1/2">
        <div className="flex flex-col items-stretch justify-between w-full p-4 rounded-md md:w-96 min-h-[300px] bg-slate-100">
          {/* --------------------------------- HEADER --------------------------------- */}
          <div className="flex items-center gap-4 pb-4 border-b border-slate-300">
            <div className="flex items-center justify-center w-5 h-5 rounded-md bg-slate-300">
              <HashtagIcon color="#546e7a" style={{ transform: "scale(0.9)" }} />
            </div>
            <span className="flex items-center h-6">{v.product?.accountingCode}</span>
          </div>

          {/* --------------------------------- CONTENT -------------------------------- */}
          <div className="flex flex-col items-center justify-center gap-4 py-4 w-">
            <Icon
              rounded
              url={v.product?.imageUrl || productImage}
              classes={{ l1: "w-20 h-20 border-2", l2: "w-auto h-auto", l3: "h-full" }}
            />
            <span className="text-lg text-dark-1">{v.product?.title || "نام کالا"}</span>
            <span className="text-base text-dark-3">
              {v.product?.barcodes?.join(", ") || "شماره سریال کالا"}
            </span>
          </div>

          {/* --------------------------------- FOOTER --------------------------------- */}
          <div className="flex flex-wrap items-center justify-around gap-4">
            <div className="flex items-center gap-2">
              <span className="text-dark-3">واحد اصلی:</span>
              <span>{v.product?.unit}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-dark-3">واحد فرعی:</span>
              <span>{v.product ? v.product.subUnit || "ندارد" : ""}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
